import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";
import { MenuPackage } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/context-menu-injector";
import { ContextMenuService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/context-menu.service";
import { MenuComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/menu.component";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { take } from "rxjs/operators";
import { AccountService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { Permission } from "projects/sepidz-web-framework/src/lib/models";
import { SettlementFormSettingFormComponent } from "./settlementformsetting/settlementformsetting-form.component";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "simple-menu",
  template: `
    <a class="simple-menu-box" (click)="handleClick(this.menuPackage.context.value)">
      {{ message }}
    </a>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleMenuComponent extends MenuComponent {
  lazy = false;
  @Output() hasActiveItem = new EventEmitter<any>();
  message :string
  constructor(
    public menuPackage: MenuPackage,
    public contextMenuService: ContextMenuService,
    public dialogService: SimpleModalService,
    public accountService: AccountService,
    protected sts: ShowToastrService,
    private common: CommonService,
    private translate: TranslateService
  ) {
    super(menuPackage, contextMenuService);
    this.message = translate.instant('ClientApp.FrontOffice.Financial.CashierSettlement.Settings')
  }

  async handleClick(value: any) {
    this.contextMenuService.closeAll();
    if (!value && !this.accountService.userHasPermission(`General:SettlementFormSetting`, Permission.createPermission)) {
      this.sts.showToast("danger", "", this.translate.instant("ClientApp.FrontOffice.Financial.CashierSettlement.NotAccessThisArea"));
      return;
    }
    if (value && !this.accountService.userHasPermission(`General:SettlementFormSetting`, Permission.editPermission)) {
      this.sts.showToast("danger", "", this.translate.instant("ClientApp.FrontOffice.Financial.CashierSettlement.NotAccessThisArea"));
      return;
    }
    await this.common.getFormSetting("SettlementFormSetting").then(
      (onfulfilled) => {
        value = this.common.storage.getData(ClearableCache.FormSetting);
        this.dialogService
          .open(SettlementFormSettingFormComponent, { currentrow: value }, { autoFocus: true, closeOnClickOutside: false, closeOnEscape: false })
          .pipe(take(1))
          .subscribe((model: any) => {});
      },
      (onrejected) => {}
    );
  }
}
